import { render } from "./WorkHistoryFilters.vue?vue&type=template&id=1a12fa28&ts=true"
import script from "./WorkHistoryFilters.vue?vue&type=script&lang=ts"
export * from "./WorkHistoryFilters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__